export default __webpack_public_path__ + "static/media/logo-desktop.df3fc6d0.svg";